var _rect, _circle, _circle2, _path, _circle3, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _circle4, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "#F8F9FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 46,
    r: 18,
    fill: "#6741C6",
    fillOpacity: 0.1,
    stroke: "#6741C6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 40,
    r: 6,
    fill: "#6741C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 58C50 51.373 55.373 46 62 46H66C72.627 46 78 51.373 78 58V62H50V58Z",
    fill: "#6741C6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 42,
    r: 10,
    fill: "#6741C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42L85 46L91 40",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 72,
    width: 60,
    height: 40,
    rx: 4,
    fill: "#6741C6",
    fillOpacity: 0.1,
    stroke: "#6741C6",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 80,
    width: 44,
    height: 4,
    rx: 2,
    fill: "#6741C6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 88,
    width: 36,
    height: 4,
    rx: 2,
    fill: "#6741C6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 96,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#6741C6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 104,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#6741C6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 88,
    r: 12,
    stroke: "#6741C6",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85 88L88 91L95 84",
    stroke: "#6741C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/onboarding.62cb41d9b6c9afa4d93cf23625a9f93d.svg";
export { ForwardRef as ReactComponent };